import FILES_DOMAIN from './domain'
import FILES_KEY from './key'

const FILES_PATH = {
  DATA: `${FILES_DOMAIN}.${FILES_KEY.DATA}`
}

export default FILES_PATH
